import './index.scss';
import {jump} from '../../tools';
import {inject, observer} from 'mobx-react';

@inject(({store}) => {
    return {
        taoCanTab: store.taoCanTab,
        showTaoCanList: store.showTaoCanList,
        changeTab: store.changeTab
    };
})
@observer
class Products extends React.Component {
    state = {
        activeIndex: 0,
        isMore: true
    }

    setActiveIndex(index, id) {
        let {activeIndex} = this.state;
        if (activeIndex === index) {
            return;
        } else {
            this.setState({activeIndex: index});
        }
        this.props.changeTab(id, 'taocan');
    }

    changeMore() {
        this.setState({isMore: !this.state.isMore});
    }

    render() {
        const {taoCanTab, showTaoCanList = []} = this.props;
        const {activeIndex, isMore} = this.state;
        if (!showTaoCanList.length) {
            return null;
        }
        return (
            <div className="products">
                <img src="https://s.qunarzz.com/vacation_tuan/2023/abudhabi/title2.jpg"/>
                <div className="taocan">
                    <div className="taocan-tab">
                        {
                            taoCanTab.map((item, index) => {
                                return (
                                    <div
                                        className={`taocan-tab-item ${index === activeIndex ? 'active' : ''}`}
                                        onClick={() => this.setActiveIndex(index, item.id)}
                                        key={item.id}
                                    >
                                        {item.title}
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="taocan-list">
                        {
                            // 对返回的产品做筛选，若产品已下线则不展示
                            showTaoCanList.filter(item => item.detail?.resource?.detail?.status === 'on sale').map((item, index) => {
                                if (index >= 4 && isMore) return null;
                                return <ProductsItem data={item.detail.resource} extraInfo={item.imgText || {}}/>;
                            })
                        }
                    </div>
                    {
                        showTaoCanList.length > 4 ? <div className="more" onClick={() => this.changeMore()}>{isMore ? '查看更多' : '收起'}</div> : null
                    }
                </div>
            </div>
        );
    }
}

// 产品item样式
const ProductsItem = (props) => {
    let {dappDetail = {}} = props.data;
    let {tags = [], title, img} = props.extraInfo;
    return (
        <div className="taocan-list-item">
            <div className="left">
                <img src={img || dappDetail.img}/>
            </div>
            <div className="right">
                <div className="title">{title || dappDetail.title}</div>
                <div className="sale-point">
                    {tags.length ? `·${tags[0].tag}` : ''}
                </div>
                <div className="btn" onClick={() => jump(dappDetail.jumpInfo)} data-sk-eid="abu_dujia">
                    <div className="price">
                        <sapn className="t">￥</sapn>
                        {dappDetail.price.price / 100}
                        <span className="unit">{dappDetail.price.type === 'NORMAL' ? '起/人' : '起/份'}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Products;